/* This file is auto-generated by 'tools/data-lib-gen'. Please don't edit it manually. */
import type { UserPreferences } from '../models/UserPreferences';
import type { UserPreferencesShow } from '../models/UserPreferencesShow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as request } from '../core/Request';
import type { RequestConfig } from '../core/Request';

export class UserPreferencesService {
  /**
   * Show user preference data
   * @returns user_preferences_show successful
   * @throws ApiError
   */
  public listAtreusV2UserPreferences(): CancelablePromise<UserPreferencesShow> {
    return request(this.config, {
      method: 'GET',
      url: '/kratos/atreus/v2/user_preferences'
    });
  }
  /**
   * Update user_preferences
   * @returns void
   * @throws ApiError
   */
  public putAtreusV2UserPreferences({
    requestBody
  }: {
    requestBody?: UserPreferences;
  }): CancelablePromise<void> {
    return request(this.config, {
      method: 'PUT',
      url: '/kratos/atreus/v2/user_preferences',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * Destroy user_preferences
   * @returns void
   * @throws ApiError
   */
  public deleteAtreusV2UserPreference({
    kratosAtreusInstituteId
  }: {
    kratosAtreusInstituteId: number;
  }): CancelablePromise<void> {
    return request(this.config, {
      method: 'DELETE',
      url: '/kratos/atreus/v2/user_preferences/{kratos_atreus_institute_id}',
      path: {
        kratos_atreus_institute_id: kratosAtreusInstituteId
      }
    });
  }

  constructor(private config?: RequestConfig) {}
}
